export const getRegistrationErrorMessage = (errors: any, touched: any) => {
  if (
    errors?.registrationData?.activeRegistration &&
    touched?.registrationData?.activeRegistration
  ) {
    return 'Selecione a opção que deseja de "Cadastro Ativo" abaixo para prosseguir.';
  }
  if (
    errors?.registrationData?.blockRegistration &&
    touched?.registrationData?.blockRegistration
  ) {
    return 'Selecione a opção que deseja de "Bloquear Cadastro" abaixo para prosseguir.';
  }
  return null;
};
